export default __webpack_public_path__ + "static/media/logo.39ac2537.png";